<template>
    <el-drawer v-model="param.view" title="会员续费记录" size="80%" direction="rtl" :before-close="handleClose">
        <div class="TTL-table top20">
            <el-table :data="list" stripe="true" empty-text="" @selection-change="selecttable">
                <template v-slot:empty><el-empty description="暂无数据" /></template>
                <el-table-column prop="vip_name" label="vip名称" align="center" min-width="150">
                    <template #default="scope">
                        <div>{{scope.row.vip_name}}</div>
                    </template>
                </el-table-column>
                <el-table-column label="期初时间" align="center" min-width="150">
                    <template #default="scope">
                        <div>{{scope.row.basenums ? scope.row.basenums : '/' }}</div>
                    </template>
                </el-table-column>
                <el-table-column label="充值/退款时间" align="center" min-width="150">
                    <template #default="scope">
                        <div>{{scope.row.nums ? scope.row.nums : '/' }}</div>
                    </template>
                </el-table-column>
                <el-table-column label="结余时间" align="center" min-width="150">
                    <template #default="scope">
                        <div>{{scope.row.endnums ? scope.row.endnums : '/' }}</div>
                    </template>
                </el-table-column>
                <el-table-column label="期初金额" align="center" min-width="150">
                    <template #default="scope">
                        <div>{{scope.row.begin_price ? scope.row.begin_price : '/' }}</div>
                    </template>
                </el-table-column>
                <el-table-column label="充值/退款金额" align="center" min-width="150">
                    <template #default="scope">
                        <div>{{scope.row.price ? scope.row.price : '/' }}</div>
                    </template>
                </el-table-column>
                <el-table-column label="结余金额" align="center" min-width="150">
                    <template #default="scope">
                        <div>{{scope.row.end_price ? scope.row.end_price : '/' }}</div>
                    </template>
                </el-table-column>
                <el-table-column label="时间范围" align="center" min-width="280">
                    <template #default="scope">
                        <div class="expire-time">{{scope.row.starttime+' ~ '+scope.row.endtime}}</div>
                        <div class="expire-time">{{scope.row.isexpire ? '(有效)' : '(过期)'}}</div>
                    </template>
                </el-table-column>
                <el-table-column label="最后操作时间" align="center" min-width="150">
                    <template #default="scope">
                        <div>{{scope.row.inputtime}}</div>
                    </template>
                </el-table-column>
            </el-table>
        </div>

    </el-drawer>
</template>

<script>
import INTERFACE_MODEL_VIP from '@/Interface/Es/vip';
export default {
    props:['view','memberid'],
    data() {
        return {
            logview:false,
            logmemberid:'',

            param: {
                view:false,
                memberid:'',
                p:1,
                rollpage:10,
                ischange:false,
                rows:0,
            },
            list:[],

        }
    },
    watch: {
        view(val){
            if(val) {
                this.param.view=true;
                this.param.memberid=this.memberid;
                this.param.ischange=true;
                this.GetLogList();
            }
        },
    },
    mounted() {
        
    },
    methods: {


        /** 列表数据搜索 **/
        GetLogList() {
            if(this.param.ischange) {
                this.param.ischange=false;
                this.param.p=1;
                this.param.rollpage=10;
            }

            INTERFACE_MODEL_VIP.GET_VIP_RENEW_LIST(this.param).then((res) => {
                 if(res.status > 0) return false;
                 this.param.rows=res.data.count;
                 this.list=res.data.list;
            });
        },


        /** 关闭窗口 **/
        handleClose() {
            this.param.view=false;
            this.$emit('finish');
        },

    },
}
</script>
<style scoped>
.auth-box {display: inline-block;width:100%;}
.auth-box-item {display: inline-flex;align-items: center;width:100%;position:relative;}
.auth-title {display: inline-flex;align-items: center;font-size:16px;font-weight: bold;}
.auth-title span {font-size:12px;line-height: 12px;color:#666666;padding:4px 10px;border-radius: 20px;border:1px solid #666666;font-weight: normal;}
.auth-status {color:#ffffff !important;background-color: #666eeb;border-color:#666eeb !important;}
.auth-box-content-title {display: inline-block;font-size:13px;color:#333333;width:25%;}
.auth-box-content {display: inline-block;font-size:13px;color:#333333;}
.auth-error {font-size:13px;color:red !important;border:none !important;}
.TTL-btn-box {display: inline-flex;justify-content: flex-end;align-items: center;width:100%;margin-bottom:20px;}
.expire-time {display: inline-block;width:100%;text-align: center;}
</style>